<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import { format, locale } from 'svelte-i18n';
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system/index';
	import { mobile } from 'src/services/mobile-rework';
	import { capFirstChar } from 'src/helpers/utilities';
	import { navigateToUrl } from '../Lists/list-helpers';

	export let showModal = false;
	export let urlPath = '';
	export let imageUrl = '';
	export let modalTitle = '';
	export let heading = '';
	export let secondHeading = '';
	export let subHeading = '';
	export let dateSentence = ''; // html format translation
	export let text = '';
	export let subText = '';
	export let afterText = '';
	export let buttonText = $format('button_shop_now', {
		default: 'Shop now',
	});
	export let discount = '';

	const dispatch = createEventDispatcher();

	const onCloseModal = () => dispatch('close');

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', onCloseModal);
			return () => mobile.removeEventListener('back_button', onCloseModal);
		}
	});

	$: navigationLink = `https://www.shelly.com/${['de', 'fr'].includes($locale) ? `${$locale}/` : ''}${urlPath}`;
</script>

<Modal {showModal} on:close={onCloseModal} title={modalTitle}>
	<Container slot="content">
		<div class="d-flex align-items-center flex-direction-column">
			<div class="d-flex justify-content-center align-items-center mb-m">
				<img
					class="width-full height-full"
					style="object-fit: contain;"
					src={imageUrl}
					alt={imageUrl}
				/>
			</div>
			{#if $$slots.default}
				<slot />
			{:else}
				{#if heading}
					<Text class="mb-m text-center text-primary text-bold" element="h1">
						{heading}
					</Text>
				{/if}
				{#if secondHeading}
					<Text class="mb-m text-center" element="h1">
						{secondHeading}
					</Text>
				{/if}
				{#if subHeading}
					<Text class="mb-m text-center text-semibold" element="h2">
						{$format('subtitle_smart_home_challenge', {
							default: 'Show off your Smart Home setup and win!',
						})}
					</Text>
				{/if}
				{#if discount}
					<Container type="primary-10" class="mb-m text-center width-full">
						<div class="mb-s text-center">
							<Text class="d-inline" element="h1">
								{capFirstChar(
									$format('span_up_to', {
										default: 'up to',
									}),
								)}
							</Text>
							<Text
								class="d-inline text-bold text-primary"
								element="h1"
								style=" font-size: 32px !important;">{discount}</Text
							>
							<Text class="d-inline" element="h1">
								{$format('label_discount', {
									default: 'discount',
								})}
							</Text>
						</div>
						<Text styleType="body-small" class="text-200">
							{$format('text_selected_devices', {
								default: 'on selected Shelly devices.',
							})}
						</Text>
					</Container>
				{/if}
				{#if text}
					<Text class="text-center text-300">
						{text}
					</Text>
				{/if}
				{#if subText}
					<Text class="mb-m text-center text-300">
						{subText}
					</Text>
				{/if}
				{#if dateSentence}
					<Text class={`${!afterText ? 'mb-m' : ''} text-center text-300`}>
						{@html dateSentence}
					</Text>
				{/if}
				{#if afterText}
					<Text class="mb-m text-center text-300">
						{afterText}
					</Text>
				{/if}
			{/if}
			<Button class="mb-m" variant="primary" on:click={() => navigateToUrl(navigationLink)}
				>{buttonText}</Button
			>
			<Text class="text-primary cursor-pointer" on:click={onCloseModal}
				>{capFirstChar($format('button_maybe_later', { default: 'Maybe later' }))}</Text
			>
		</div>
	</Container>
</Modal>
